import React from 'react';
import { Typography } from 'antd';

type SettingsSectionProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
};

const SettingsSection: React.FC<SettingsSectionProps> = ({ title, description, children }) => (
  <div>
    <Typography.Text strong>{title}</Typography.Text>
    {description && (
      <Typography.Paragraph type="secondary" style={{ marginBottom: 12 }}>
        {description}
      </Typography.Paragraph>
    )}
    {children}
  </div>
);

export default SettingsSection;
